import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable()
export class BlockingProgressService {
  public isLoading: Observable<boolean>;
  public loadingMessage: Observable<string>;

  private _isLoading$: BehaviorSubject<boolean>;
  private _loadingMessage$: BehaviorSubject<string>;

  constructor() {
    this._isLoading$ = new BehaviorSubject(false);
    this._loadingMessage$ = new BehaviorSubject(null);
    this.isLoading = this._isLoading$.asObservable();
    this.loadingMessage = this._loadingMessage$.asObservable();
  }

  public block(message?: string): string {
    if (!this._isLoading$.value) {
      this._isLoading$.next(true);
      this._loadingMessage$.next(message ? message : null);
      return Date.now().toString();
    }
    return null;
  }

  public unBlock(): void {
    if (this._isLoading$.value) {
      this._isLoading$.next(false);
      this._loadingMessage$.next(null);
    }
  }
}
